import { MaterialRequisitionFormResponse } from '@Types/api/form';
// import { RequestListSearchResponse } from '@Types/api/requestList';
import { parseDateTime } from '@Utils/transformDateTime';
import { TypeDict } from 'types';
import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';

import { ColumnDataType } from './type';

export const dataSourceMap = (
  data: MaterialRequisitionFormResponse[],
  findStatus: (statusNum: number) => TypeDict | undefined,
  findCostCenterType: (ccTypeId: number) => TypeDict | undefined
): Array<ColumnDataType> => {
  if (!data?.length) return [];

  return data?.map((requestItem) => ({
    key: requestItem.requisitionId,
    requestNo: requestItem.reqNo,
    requestDate: parseDateTime(requestItem.reqDate),
    requestType: 'Material',
    requestDescription: requestItem.headerDesc || EMPTY_FIELD_PLACEHOLDER,
    approverName: requestItem.approverName,
    costCenterType:
      findCostCenterType(requestItem.ccTypeId)?.codeDesc ||
      EMPTY_FIELD_PLACEHOLDER,
    costCenter: requestItem?.costCenterName || EMPTY_FIELD_PLACEHOLDER,
    createdOn: parseDateTime(requestItem.createdOn),
    status: findStatus(requestItem.statusId)?.codeDesc || '',
    action: '',
  }));
};
